(function () {
  if (window.__evoEmailMarketingInitialized) return;
  window.__evoEmailMarketingInitialized = true;

  var COUPON = 'NEW12';
  var successNodes = new WeakSet();

  function pageType() {
    var bodyClass = document.body && document.body.className ? String(document.body.className) : '';
    var match = bodyClass.match(/template-([a-z0-9_-]+)/i);
    return match ? match[1] : 'site';
  }

  function locale() {
    return document.documentElement.getAttribute('lang') ||
      (window.Shopify && window.Shopify.locale) ||
      '';
  }

  function productHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function tagsFromNode(node) {
    var form = node && node.closest && node.closest('form');
    var input = form && form.querySelector('[name="contact[tags]"]');
    return input ? String(input.value || '') : '';
  }

  function tagValue(tags, prefix) {
    var parts = String(tags || '').split(',');
    for (var i = 0; i < parts.length; i += 1) {
      var part = parts[i].trim();
      if (part.indexOf(prefix) === 0) return part.slice(prefix.length);
    }
    return '';
  }

  function contextFromNode(node, extra) {
    var host = node && node.closest && node.closest('[data-evo-marketing-source], promotion-popup, .evo-newsletter, .email-signup-block');
    var dataset = host && host.dataset ? host.dataset : {};
    var tags = tagsFromNode(node);
    var payload = {
      source: dataset.evoMarketingSource || (host && host.tagName === 'PROMOTION-POPUP' ? 'promotion_popup' : 'newsletter'),
      page_type: dataset.evoPageType || pageType(),
      locale: dataset.evoLocale || locale(),
      coupon: COUPON,
      product_handle: dataset.evoProductHandle || tagValue(tags, 'product:') || productHandle() || undefined,
      version: dataset.evoProductVersion || tagValue(tags, 'version:') || undefined,
      breast_type: dataset.evoBreastType || tagValue(tags, 'breast:') || undefined
    };
    return Object.assign(payload, extra || {});
  }

  function emit(eventName, detail) {
    var payload = Object.assign({ event: eventName }, detail || {});
    try {
      window.evolovaDataLayer = window.evolovaDataLayer || [];
      window.evolovaDataLayer.push(payload);
    } catch (_) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (_) {}
    try {
      document.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
    } catch (_) {}
  }

  function isNewsletterForm(form) {
    return !!(
      form &&
      form.matches &&
      form.querySelector('[name="contact[email]"]') &&
      (form.matches('.evo-newsletter__fallback-form, .email-signup__form') || form.closest('promotion-popup, .evo-newsletter, .email-signup-block'))
    );
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!isNewsletterForm(form)) return;
    var detail = contextFromNode(form, { form_id: form.id || undefined });
    emit('evolova_newsletter_submit', detail);
    if (form.closest('promotion-popup')) emit('evolova_promo_popup_submit', detail);
  }, true);

  function markSuccess(node) {
    if (!node || successNodes.has(node)) return;
    successNodes.add(node);
    emit('evolova_newsletter_success', contextFromNode(node, { success_source: 'shopify_form' }));
  }

  function scanSuccess(root) {
    var scope = root && root.querySelectorAll ? root : null;
    if (!scope) return;
    scope.querySelectorAll('.evo-newsletter__message--success, .email-signup__message--success').forEach(markSuccess);
  }

  function isOmnisendNode(node) {
    if (!node || node.nodeType !== 1) return false;
    var id = String(node.id || '').toLowerCase();
    var className = String(node.className || '').toLowerCase();
    return id.indexOf('omnisend') !== -1 ||
      className.indexOf('omnisend') !== -1 ||
      (node.hasAttribute && node.hasAttribute('data-omnisend'));
  }

  function isMarketingRoot(node) {
    return !!(
      node &&
      node.nodeType === 1 &&
      ((node.matches && node.matches('[data-evo-marketing-source], promotion-popup, .evo-newsletter, .email-signup-block, .shopify-app-block')) ||
        isOmnisendNode(node))
    );
  }

  function closestMarketingRoot(node) {
    if (!node || node.nodeType !== 1) return null;
    if (isMarketingRoot(node)) return node;
    var closest = node.closest && node.closest('[data-evo-marketing-source], promotion-popup, .evo-newsletter, .email-signup-block, .shopify-app-block');
    if (closest) return closest;
    var parent = node.parentElement;
    while (parent) {
      if (isOmnisendNode(parent)) return parent;
      parent = parent.parentElement;
    }
    return null;
  }

  function findMarketingRoots(root) {
    if (!root || root.nodeType !== 1) return [];
    var roots = [];
    if (isMarketingRoot(root)) roots.push(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-evo-marketing-source], promotion-popup, .evo-newsletter, .email-signup-block, .shopify-app-block').forEach(function (node) {
        roots.push(node);
      });
      root.querySelectorAll('[id], [class], [data-omnisend]').forEach(function (node) {
        if (isOmnisendNode(node)) roots.push(node);
      });
    }
    return roots;
  }

  findMarketingRoots(document.documentElement).forEach(scanSuccess);

  // evo-email-marketing-observer-guard-20260714:
  // Scope success detection to newsletter/popup/app roots and coalesce scans.
  var queuedRoots = [];
  var queuedRootSet = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var pendingScanFrame = 0;

  function queueRoot(root) {
    if (!root || root.nodeType !== 1) return;
    if (queuedRootSet && queuedRootSet.has(root)) return;
    if (queuedRootSet) queuedRootSet.add(root);
    queuedRoots.push(root);
    if (pendingScanFrame) return;
    pendingScanFrame = window.requestAnimationFrame(function () {
      var roots = queuedRoots.slice(0, 24);
      queuedRoots = [];
      queuedRootSet = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
      pendingScanFrame = 0;
      roots.forEach(scanSuccess);
    });
  }

  var successObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.evo-newsletter__message--success, .email-signup__message--success')) {
          if (closestMarketingRoot(node)) markSuccess(node);
          return;
        }
        var root = closestMarketingRoot(node);
        if (root) {
          queueRoot(root);
          return;
        }
        findMarketingRoots(node).forEach(queueRoot);
      });
    });
  });

  successObserver.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(function () {
    successObserver.disconnect();
    if (pendingScanFrame) {
      window.cancelAnimationFrame(pendingScanFrame);
      pendingScanFrame = 0;
    }
    queuedRoots = [];
  }, 15000);

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.promo-code__button, copy-code');
    if (!trigger) return;
    var holder = trigger.closest('[data-text], .coupon-code-block') || trigger;
    var code = holder.getAttribute('data-text') || holder.querySelector('input[readonly]')?.value || COUPON;
    emit('evolova_discount_code_copy', contextFromNode(trigger, { coupon: code || COUPON }));
  }, true);

  window.EvolovaEmailMarketing = window.EvolovaEmailMarketing || { emit: emit, contextFromNode: contextFromNode };
})();
